import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnDestroy } from '@angular/core'
import { SafeUrl } from '@angular/platform-browser'
import { EnvironmentModel } from 'apps/gb-dashboard/src/environments/environment.model'
import { SelectedAuctionFacade } from 'libs/gb-dashboard/auctions/data-access-selected-auction/src/lib/+state/selected-auction.facade'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'
import { GbNotificationService } from 'libs/shared/utils/notification/src/lib/service/gb-notification.service'
import { map, take } from 'rxjs'
import { Clipboard } from '@angular/cdk/clipboard'
import confetti from 'canvas-confetti'
import { MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'gb-setup-guide-complete-dialog',
  templateUrl: './gb-setup-guide-complete-dialog.component.html',
  styleUrls: ['./gb-setup-guide-complete-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbSetupGuideCompleteDialogComponent implements AfterViewInit, OnDestroy {
  urlName$ = this.selectedAuctionFacade.urlName$
  frontendUrl$ = this.urlName$.pipe(map((urlName) => `${this.appConfig.frontendUrl}${urlName}`))
  qrCodeDownloadLink: SafeUrl = ''
  private confettiInstance = confetti.create(undefined, { useWorker: false, resize: true })

  constructor(
    private selectedAuctionFacade: SelectedAuctionFacade,
    private clipboard: Clipboard,
    private gbNotificationService: GbNotificationService,
    private dialogRef: MatDialogRef<GbSetupGuideCompleteDialogComponent>,
    @Inject(APP_CONFIG) protected appConfig: EnvironmentModel,
  ) {}

  ngAfterViewInit(): void {
    this.dialogRef
      .afterOpened()
      .pipe(take(1))
      .subscribe(() => this.fireConfetti())
  }

  ngOnDestroy(): void {
    this.confettiInstance.reset()
  }

  private fireConfetti(): void {
    this.confettiInstance({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
      zIndex: 2000,
    })
  }

  openUrl(url: string): void {
    window.open(url, '_blank')
  }

  copyUrl(url: string) {
    this.clipboard.copy(url)
    this.gbNotificationService.success('SETUP_GUIDE.COMPLETE_DIALOG.LINK_COPIED')
  }

  onChangeURL(url: SafeUrl) {
    this.qrCodeDownloadLink = url
  }
}
